/* Johns Electrical mobile filters. Idempotent, source-control only. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 900px)');
  var initialized = false;
  var uid = 0;

  function text(el) { return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function controlsIn(blocks) {
    var found = [];
    blocks.forEach(function(block){ Array.prototype.forEach.call(block.querySelectorAll('select,input,[aria-pressed="true"]:not([data-je-shopping-shortcut-key])'), function(el){ if (found.indexOf(el) < 0) found.push(el); }); });
    return found;
  }
  function isMeaningfulControl(el) {
    if (el.type === 'hidden' || el.disabled) return false;
    if (el.matches('[data-cmain-deals-sort-select],[data-ghost-sort],.sort-select,[name="sort_by"]')) return false;
    if (el.tagName === 'SELECT') return el.value !== (el.options[el.selectedIndex] && el.options[el.selectedIndex].defaultSelected ? el.value : (Array.prototype.filter.call(el.options, function(o){ return o.defaultSelected; })[0] || el.options[0] || {}).value);
    return el.value && !el.defaultValue;
  }
  function activeCount(blocks) {
    var n = 0;
    controlsIn(blocks).forEach(function (el) {
      if ((el.tagName === 'SELECT' || el.tagName === 'INPUT') && isMeaningfulControl(el)) n++;
      if (el.getAttribute('aria-pressed') === 'true') n++;
    });
    blocks.forEach(function(block){ n += block.querySelectorAll('.je-ghost__tab[aria-current="true"]').length; });
    return n;
  }
  function focusable(root) { return Array.prototype.slice.call(root.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(function(el){ return !el.disabled && el.offsetParent !== null; }); }

  function makeShell(label) {
    var id = 'je-mf-' + (++uid);
    var trigger = document.createElement('button');
    trigger.type = 'button'; trigger.className = 'je-mf-trigger'; trigger.setAttribute('aria-controls', id); trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML = '<span>' + label + '</span><span class="je-mf-trigger__meta"></span><svg class="je-mf-trigger__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M7 12h10M10 17h4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    var sheet = document.createElement('div'); sheet.className = 'je-mf-sheet'; sheet.hidden = true;
    sheet.innerHTML = '<button type="button" class="je-mf-sheet__veil" aria-label="Close filters"></button><section id="' + id + '" class="je-mf-sheet__dialog" role="dialog" aria-modal="true" aria-label="' + label + '"><span class="je-mf-sheet__handle" aria-hidden="true"></span><header class="je-mf-sheet__head"><h2 class="je-mf-sheet__title">' + label + '</h2><span class="je-mf-sheet__count" aria-live="polite"></span><button type="button" class="je-mf-sheet__close" aria-label="Close filters">×</button></header><div class="je-mf-sheet__body"></div><footer class="je-mf-sheet__foot"><button type="button" class="je-mf-sheet__reset">Reset</button><button type="button" class="je-mf-sheet__done">Show results</button></footer></section>';
    var host = document.querySelector('#MainContent') || document.body;
    sheet.classList.add('je-ghost');
    host.appendChild(sheet);
    return { trigger: trigger, sheet: sheet, body: sheet.querySelector('.je-mf-sheet__body'), count: sheet.querySelector('.je-mf-sheet__count') };
  }

  function enhance(source, blocks, countEl, label) {
    if (!source || source.dataset.jeMobileFiltersReady === '1') return;
    source.dataset.jeMobileFiltersReady = '1';
    source.classList.add('je-mf-enhanced');
    var shell = makeShell(label), open = false, opener = null, placeholders = [];
    blocks = blocks.filter(Boolean);
    var triggerAnchor = blocks[0] || source;
    triggerAnchor.parentNode.insertBefore(shell.trigger, triggerAnchor);
    function update() {
      var active = activeCount(blocks), result = text(countEl);
      shell.trigger.querySelector('.je-mf-trigger__meta').textContent = active ? active + ' applied' : (result || 'Filter & sort');
      shell.count.textContent = result || (active ? active + ' filters applied' : '');
      shell.sheet.querySelector('.je-mf-sheet__done').textContent = result ? 'Show results' : 'Done';
    }
    function restore() {
      if (!open) return;
      for (var i = 0; i < blocks.length; i++) { blocks[i].classList.remove('je-mf-in-sheet'); placeholders[i].parentNode.insertBefore(blocks[i], placeholders[i]); }
      placeholders.forEach(function(p){ p.parentNode.removeChild(p); }); placeholders = [];
      shell.sheet.hidden = true; shell.trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('je-mf-locked'); document.body.classList.remove('je-mf-locked'); open = false;
      if (opener && document.contains(opener)) opener.focus(); opener = null;
    }
    function show() {
      if (!mq.matches || open) return;
      opener = document.activeElement; placeholders = blocks.map(function(block){ var p=document.createComment('je-mobile-filters'); block.parentNode.insertBefore(p, block); return p; });
      blocks.forEach(function(block){ block.classList.add('je-mf-in-sheet'); shell.body.appendChild(block); });
      shell.sheet.hidden = false; shell.trigger.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('je-mf-locked'); document.body.classList.add('je-mf-locked'); open = true; update();
      requestAnimationFrame(function(){ shell.sheet.querySelector('.je-mf-sheet__close').focus(); });
    }
    function reset() {
      controlsIn(blocks).forEach(function(el){
        if (el.tagName === 'SELECT') {
          var defaultOption = Array.prototype.filter.call(el.options, function(o){ return o.defaultSelected; })[0] || el.options[0];
          if (defaultOption && el.value !== defaultOption.value) { el.value = defaultOption.value; el.dispatchEvent(new Event('change', {bubbles:true})); }
        } else if (el.tagName === 'INPUT' && el.type !== 'hidden' && el.value !== el.defaultValue) {
          el.value = el.defaultValue; el.dispatchEvent(new Event('input', {bubbles:true})); el.dispatchEvent(new Event('change', {bubbles:true}));
        }
      });
      blocks.forEach(function(block){ Array.prototype.forEach.call(block.querySelectorAll('[aria-pressed="true"]:not([data-je-shopping-shortcut-key])'), function(el){ el.click(); }); });
      blocks.forEach(function(block){ var clear=block.querySelector('[data-cmain-spec-clear],[data-ghost-active-clear]'); if (clear) clear.click(); }); update();
      var stockTab = null;
      blocks.forEach(function(block){ stockTab = stockTab || block.querySelector('[data-cmain-tab="instock"]'); });
      if (stockTab && stockTab.getAttribute('aria-selected') !== 'true') stockTab.click();
    }
    shell.trigger.addEventListener('click', show); shell.sheet.querySelector('.je-mf-sheet__veil').addEventListener('click', restore); shell.sheet.querySelector('.je-mf-sheet__close').addEventListener('click', restore); shell.sheet.querySelector('.je-mf-sheet__done').addEventListener('click', restore); shell.sheet.querySelector('.je-mf-sheet__reset').addEventListener('click', reset);
    document.addEventListener('keydown', function(e){
      if (!open || (e.key !== 'Escape' && e.key !== 'Tab')) return;
      var popover = null;
      if ('showPopover' in HTMLElement.prototype) popover = document.querySelector('[popover]:popover-open');
      if (e.key === 'Escape') {
        if (popover && !shell.sheet.contains(popover)) return;
        e.preventDefault(); restore(); return;
      }
      if (!shell.sheet.contains(document.activeElement)) {
        if (popover && popover.contains(document.activeElement)) { e.preventDefault(); shell.sheet.querySelector('.je-mf-sheet__close').focus(); }
        return;
      }
      var items=focusable(shell.sheet.querySelector('.je-mf-sheet__dialog'));
      if (!items.length) return;
      var a=items[0], b=items[items.length-1];
      if (e.shiftKey && document.activeElement===a) { e.preventDefault(); b.focus(); }
      else if (!e.shiftKey && document.activeElement===b) { e.preventDefault(); a.focus(); }
    }, true);
    blocks.forEach(function(block){ block.addEventListener('input', update, true); block.addEventListener('change', update, true); block.addEventListener('click', function(){ setTimeout(update, 0); }, true); });
    if (countEl && window.MutationObserver) new MutationObserver(update).observe(countEl, {childList:true, characterData:true, subtree:true});
    mq.addEventListener ? mq.addEventListener('change', function(e){ if (!e.matches) restore(); }) : mq.addListener(function(e){ if (!e.matches) restore(); });
    update();
  }

  function init() {
    if (initialized) return; initialized = true;
    var bar = document.querySelector('[data-je-mobile-filter-source="collection"]');
    if (bar) enhance(bar, [bar], document.querySelector('[data-cmain-count]'), 'Filter & sort');
    var ghost = document.querySelector('[data-je-mobile-filter-source="ghost"]');
    if (ghost) enhance(ghost, [ghost.querySelector('.je-ghost__catbar'), ghost.querySelector('[data-ghost-active]'), ghost.querySelector('.je-ghost__bar')], ghost.querySelector('[data-ghost-count]'), 'Browse & filter');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
